import axios from '@/store/api.js'
var VueCookie = require('vue-cookie')

const state = {
    routerHistory: null,
    firstTimeLogIn: true,
    loginAgain: false,
    userInfo: {
        userId: null,
        name: null,
        phoneNumber: null,
        email: null,
        emailCc: null,
        organizationId: null
    },
    codelists: [],
    regnskabList: [],
    selectedRegnskab: null,
    regnskabSetting: [],
    selectedBalance: {}
}

const getters = {
    getRouterHistory: state => {
        return state.routerHistory
    },
    firstTimeLogIn: state => {
        return state.firstTimeLogIn
    },
    getLoginAgain: state => {
        return state.loginAgain
    },
    userInfo: state => {
        return state.userInfo
    },
    getCodelists: state => {
        return state.codelists
    },
    getRegnskabList: state => (regnskabId) => {
        // 1 = dandas
        // 4 = asset
        if (regnskabId) {
            const foundRegnskab = state.regnskabList.find(r => r.id === regnskabId)
            if (foundRegnskab) {
                return foundRegnskab
            }
        } else {
            return state.regnskabList
        }
    },
    getSelectedRegnskab: state => {
        return state.selectedRegnskab
    },
    getRegnskabSetting: state => {
        return state.regnskabSetting
    },
    getProjectStatus: state => {
        return state.codelists.projectStatus
    },
    getSelectedBalance: state => {
        return state.selectedBalance
    }
}

const mutations = {
    setRouterHistory: (state, router) => {
        state.routerHistory = router
    },
    setFirstTimeLogIn: (state, payload) => {
        state.firstTimeLogIn = payload
    },
    setLoginAgain: (state, boolean) => {
        state.loginAgain = boolean
    },
    setCurrentUserInfo: (state, userInfo) => {
        state.userInfo = userInfo
    },
    setCodeLists: (state, codelists) => {
        state.codelists = codelists
    },
    setRegnskabList: (state, regnskabList) => {
        state.regnskabList = regnskabList
    },
    setSelectedRegnskab: (state, selectedRegnskab) => {
        state.selectedRegnskab = selectedRegnskab
    },
    setRegnskabSetting: (state, regnskabSetting) => {
        state.regnskabSetting = regnskabSetting
    },
    setSelectedBalance: (state, regnskabSetting) => {
        regnskabSetting.sort((a, b) => {
            if (a.sortering > b.sortering) {
                return 1
            } else if (a.sortering < b.sortering) {
                return -1
            }
            return 0
        })

        state.selectedBalance = regnskabSetting[0]
    }

}

const actions = {
    ping: ({commit}, token) => {
        let tokenUrl
        if (token && (token.tokenId && token.tokenValue)) {
            tokenUrl = 'tokenid=' + token.tokenId + '&tokenvalue=' + token.tokenValue
        }
        return axios.get('/Account/Ping?' + tokenUrl).then((response) => {
            return new Promise((resolve, reject) => {
                if (response.data.authenticated) {
                    resolve(true)
                } else {
                    resolve(false)
                }
            })
        })
    },
    setRouterHistory: ({ commit }, route) => {
        commit('setRouterHistory', route)
    },
    setFirstTimeLogIn: ({ commit }, boolean) => {
        commit('setFirstTimeLogIn', boolean)
    },
    setLoginAgain: ({ commit }, boolean) => {
        commit('setLoginAgain', boolean)
    },
    async getCurrentUserInfo ({ commit }) {
        try {
            const response = await axios.post('/Account/GetCurrentUserInfo')
            if (response) {
                commit('setCurrentUserInfo', response.data)
                return response.data
            }
        } catch (err) {
            throw err
        }
    },
    async getAllCodeLists ({ commit }) {
        try {
            const codelists = await axios.post('/Value/Setting/GetAllCodeLists')
            if (codelists) {
                commit('setCodeLists', codelists.data)
            }
        } catch (err) {
            throw err
        }
    },
    async getRegnskabList ({ commit }, id) {
        try {
            const regnskabList = await axios.post('/Value/Setting/GetRegnskab', {id: id || null})
            if (regnskabList) {
                commit('setRegnskabList', regnskabList.data)
            }
        } catch (err) {
            throw err
        }
    },
    async setSelectedRegnskab ({ commit }, regnskab) {
        let aId = null
        try {
            if (regnskab.id) {
                VueCookie.set('selectedRegnskab', regnskab.id, {expires: '1Y'})
                commit('setSelectedRegnskab', regnskab)
                aId = regnskab.id
            } else {
                if (state.regnskabList.length > 0) {
                    state.regnskabList.forEach(r => {
                        if (r.id.toString() === regnskab) {
                            commit('setSelectedRegnskab', r)
                            aId = r.id
                        }
                    })
                } else {
                    commit('setSelectedRegnskab', regnskab)
                    aId = regnskab
                }
            }

            const settings = await axios.post('/Value/Setting/GetRegnskabSetting', {id: aId})
            if (settings) {
                commit('setRegnskabSetting', settings.data)
                commit('setSelectedBalance', settings.data)
            }
        } catch (err) {
            throw err
        }
    }
}

export default {
    state,
    getters,
    mutations,
    actions
}



// WEBPACK FOOTER //
// ./src/store/global.js